import newWindowIcon from '@jetbrains/icons/new-window'
import Dialog from '@jetbrains/ring-ui-built/components/dialog/dialog'
import {Content, Header} from '@jetbrains/ring-ui-built/components/island/island'
import Panel from '@jetbrains/ring-ui-built/components/panel/panel'
import {Button, IconButton, Markdown} from '@jetbrains/teamcity-ui/dist/components'

import welcomeImageDark from './assets/WelcomeImage_dark.svg'
import welcomeImageLight from './assets/WelcomeImage_light.svg'
import {CALL_TO_ACTION_LABEL, CALL_TO_ACTION_LINK, TEXT, TITLE} from './WelcomePopup.consts'

import styles from './WelcomePopup.module.css'

type Props = {
  onClose: () => void
  onCallToActionClick: () => void
  show?: boolean
  isDark?: boolean
}

function WelcomePopup({show, isDark, onClose, onCallToActionClick}: Props) {
  if (!show) {
    return null
  }

  return (
    <Dialog
      closeButtonInside
      showCloseButton
      show={show}
      label={TITLE}
      contentClassName={styles.dialog}
      onCloseAttempt={onClose}
    >
      <Header>{TITLE}</Header>
      <Content className={styles.content}>
        <Markdown className={styles.text}>{TEXT}</Markdown>
        <div className={styles.imageContainer}>
          <img
            src={isDark ? welcomeImageDark : welcomeImageLight}
            alt="Linked pipelines and build configurations in a single chain"
            className={styles.image}
          />
        </div>
      </Content>
      <Panel className={styles.pager}>
        <IconButton
          primary
          withBorder
          className={styles.link}
          icon={newWindowIcon}
          href={CALL_TO_ACTION_LINK}
          target="_blank"
          rel="noreferrer"
          title={CALL_TO_ACTION_LABEL}
          onClick={onCallToActionClick}
        >
          {CALL_TO_ACTION_LABEL}
        </IconButton>
        <Button onClick={onClose}>{'Dismiss'}</Button>
      </Panel>
    </Dialog>
  )
}

export default WelcomePopup
